export const NotFound = () => {
  return (
    <div>
      <h1>Something's wrong</h1>
    </div>
  );
};
